<template>
  <div class="circle-container">
  <div class="circle"></div>
</div>
</template>

<script setup>
import { computed } from 'vue';

const radius = 45;
const center = 50;

// The path 'd' attribute defines the shape of the sector
const sectorPath = computed(() => {
  // M 50,50  -> Move to the center
  // L 50,5  -> Draw a line to the top of the circle
  // A 45,45 0 1 1 50,95 -> Draw a large arc for the full circle
  // A 45,45 0 1 1 50,5  -> And another arc back
  // Z  -> Close the path
  const path = `M ${center},${center} m 0,-${radius} a ${radius},${radius} 0 1,1 0,${2 * radius} a ${radius},${radius} 0 1,1 0,-${2 * radius}`;
  return path;
});
</script>

<style scoped>
:root {
  /* This custom property will be animated */
  --progress: 0;
}

.circle-container {
  /* Set up the parent to center the circle */
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  background-color: #e0e0e0;
  border-radius: 50%;
}

.circle {
  /* Create the conic gradient based on the custom property */
  background: conic-gradient(
    #3498db var(--progress),
    transparent var(--progress)
  );
  width: 100%;
  height: 100%;
  border-radius: 50%;
  
  /* Animate the custom property */
  animation: fill-circle 1.5s infinite linear backwards;
}

/* Register the custom property to enable a smoother animation */
@property --progress {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes fill-circle {
  to {
    --progress: 360deg;
  }
}

</style>